import { render } from "./BaseSpinButton.vue?vue&type=template&id=a227c2ca"
import script from "./BaseSpinButton.vue?vue&type=script&lang=js"
export * from "./BaseSpinButton.vue?vue&type=script&lang=js"

import "./BaseSpinButton.vue?vue&type=style&index=0&id=a227c2ca&lang=scss"

import exportComponent from "/Users/petertoh/Sites/martin-keehn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__